export enum EmergencyTypes {
    LIMIT = "L",
    FIXED = "F",
    APPROXIMATE = "A"
}
